import { useEffect, useState } from "react";
import { pointRewardTableData } from "../../data/order/pointRewardTableData";
import PointLogSortHeader from "./PointLogSortHeader";
import PointLogList from "./PointLogList";
import PointLogSearchSection from "./PointLogSearchSection";
import { pointLogTableData } from "../../data/order/pointLogTableData";
import { useMilesPoints } from "../../hooks/useMilesPoints";
import CommonPaginationSection from "../common/CommonPaginationSection";
import moment from "moment";
import { capitalize } from "lodash";

function PointsLogsSection() {
  const { getAllMilesPointsLogs } = useMilesPoints();
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);

  const loadData = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    await getAllMilesPointsLogs({
      setLoading,
      page: pagination.page,
      limit: pagination.perPage,
      callback: (data) => {
        setPagination({ ...pagination, total: data?.totalData || 10 });
        setOgData(data?.logs || []);
        setOrders((data?.logs || []).map((item) => pointLogTableData(item)));
      },
    });
  };

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage]);

  return (
    <div className="flex flex-col w-full py-4 mt-4">
      <PointLogSearchSection />
      {/* <PointLogSortHeader /> */}
      {/* <PointLogList loading={loading} ogData={ogData} orders={orders} /> */}
      <div className="w-full flex flex-col gap-2">
        {/* Header */}
        <div className="w-full p-4 flex items-center bg-[#F0F6FC] gap-2">
          <div className="w-32 ">
            <small>DATE</small>
          </div>
          <div className="flex flex-1 ">
            <small>ACTIVITY</small>
          </div>
          <div className="w-24 ">
            <small>TYPE</small>
          </div>
          <div className="w-20 ">
            <small>POINT</small>
          </div>
        </div>
        {ogData?.map((log, index) => {
          const createdAt = moment(log?.createdAt);
          const time = createdAt.format("hh:mm");
          const meridiem = createdAt.format("A").toLowerCase(); // am / pm
          const date = createdAt.format("DD/MM/YYYY");

          return (
            <div
              className="w-full p-4 flex items-center bg-white gap-2"
              key={index}
            >
              <div className="w-32 flex flex-col">
                <small>
                  {time}
                  <small className="text-primary1">{meridiem}</small>{" "}
                </small>
                <small>{date}</small>
              </div>

              <div className="flex flex-1">
                <small>{log?.activity}</small>
              </div>

              <div className="w-24">
                <LogType value={log?.type} />
              </div>

              <div className="w-20">
                <small>{(log?.point || 0)?.toLocaleString()}</small>
              </div>
            </div>
          );
        })}
      </div>
      <CommonPaginationSection
        page={pagination.page}
        perPage={pagination.perPage}
        total={pagination.total}
        callback={(page, perPage) => {
          setPagination({
            ...pagination,
            page,
            perPage,
          });
        }}
      />
    </div>
  );
}

export default PointsLogsSection;

const LogType = ({ value }) => {
  const PrefixElement = () => {
    if (value === "EARNED") {
      return (
        <div className="w-3 h-3 rounded-full bg-[#0B662C] flex shrink-0"></div>
      );
    } else {
      return (
        <div className="w-3 h-3 rounded-full bg-[#B81F25] flex shrink-0"></div>
      );
    }
  };
  return (
    <div className="flex gap-2 items-center">
      <PrefixElement />
      <span className="text-sm">{capitalize(value)}</span>
    </div>
  );
};
